module.exports = __webpack_public_path__ + "img/app_icon_32.f37ab786.png";